import { requestHandler } from "../lib/utils/network-client";

export function loginUser(payload) {
  return requestHandler("/auth/login", {
    method: "POST",
    body: payload
  });
}
